import React, { Fragment } from 'react'

const BankDetails = ({
    bank_name,
    account_title,
    account_number,
    setbank_name,
    setaccount_title,
    setaccount_number,
}) => {
    return (
        <Fragment>
            <div className="bg-white p-6 rounded-xl border border-zinc-200 shadow-sm">
                
                {/* Header */}
                <div className="flex items-center gap-4 mb-6">
                    <div className="w-10 h-10 bg-zinc-900 rounded-lg flex items-center justify-center text-white flex-shrink-0">
                        <i className="fa-solid fa-building-columns text-sm"></i>
                    </div>
                    <div>
                        <h3 className="text-base font-semibold text-zinc-900">Bank Details</h3>
                        <p className="text-xs text-zinc-500">Your bank account details.</p>
                    </div>
                </div>

                <div className="grid grid-cols-1 gap-4 mb-4">
                    {/* Bank Name */}
                    <div className="flex flex-col">
                        <label className="text-xs font-semibold text-zinc-700 mb-1.5 uppercase tracking-wider">Bank Name <span className="text-red-500">*</span></label>
                        <div className="flex border border-zinc-200 rounded-lg overflow-hidden focus-within:border-zinc-900 focus-within:ring-1 focus-within:ring-zinc-900 transition-all">
                            <input
                                type="text"
                                value={bank_name}
                                onChange={(e) => setbank_name(e.target.value)}
                                className="flex-1 px-4 py-2.5 outline-none text-sm text-zinc-800 placeholder-zinc-400 bg-white"
                                placeholder="Ex. Easy Paisa"
                            />
                            <div className="flex items-center justify-center px-4 bg-white text-zinc-400">
                                <i className="fa-solid fa-building-columns text-lg"></i>
                            </div>
                        </div>
                    </div>

                    {/* Account Holder Name */}
                    <div className="flex flex-col">
                        <label className="text-xs font-semibold text-zinc-700 mb-1.5 uppercase tracking-wider">Account Holder Name <span className="text-red-500">*</span></label>
                        <div className="flex border border-zinc-200 rounded-lg overflow-hidden focus-within:border-zinc-900 focus-within:ring-1 focus-within:ring-zinc-900 transition-all">
                            <input
                                type="text"
                                value={account_title}
                                onChange={(e) => setaccount_title(e.target.value)}
                                className="flex-1 px-4 py-2.5 outline-none text-sm text-zinc-800 placeholder-zinc-400 bg-white"
                                placeholder="Account Holder Name"
                            />
                            <div className="flex items-center justify-center px-4 bg-white text-zinc-400">
                                <i className="fa-regular fa-user text-lg"></i>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Account Number */}
                <div className="flex flex-col">
                    <label className="text-xs font-semibold text-zinc-700 mb-1.5 uppercase tracking-wider">Bank Account Number / IBAN <span className="text-red-500">*</span></label>
                    <div className="flex border border-zinc-200 rounded-lg overflow-hidden focus-within:border-zinc-900 focus-within:ring-1 focus-within:ring-zinc-900 transition-all">
                        <input
                            type="text"
                            value={account_number}
                            onChange={(e) => setaccount_number(e.target.value)}
                            className="flex-1 px-4 py-2.5 outline-none text-sm text-zinc-800 placeholder-zinc-400 bg-white"
                            placeholder="Bank Account Number / IBAN"
                        />
                        <div className="flex items-center justify-center px-4 bg-white text-zinc-400">
                            <i className="fa-regular fa-credit-card text-lg"></i>
                        </div>
                    </div>
                </div>
            </div>
        </Fragment>
    )
}

export default BankDetails
